import React from "react";
import WhatsappDefault from "../../assets/svg/WhatsappDefault";
import { TouchableHighlight, StyleSheet, View, Dimensions } from "react-native";

import Caret from "../../assets/svg/Caret";
import Text from "../AppText";
import analytics from "@services/analytics";
import { LineChart } from "react-native-chart-kit";
import { scale, verticalScale } from "../../utils/scale";

const ChartComponent = (props) => {
  const data = props.salesData.datasets[0];
  const color =
    data.data[0] > data.data[data.data.length - 1] ? "#FF0000" : "#00B01C";
  return (
    <View style={{ alignSelf: "center" }}>
      {props.salesData && (
        <LineChart
          data={props.salesData}
          width={scale(360)} // from react-native
          height={verticalScale(220)}
          yAxisLabel=""
          yAxisSuffix=""
          fromZero={0}
          // optional, defaults to 1
          chartConfig={{
            backgroundColor: "#FFFFFF",
            backgroundGradientFrom: "#FFFFFF",
            backgroundGradientTo: "#FFFFFF",
            fillShadowGradient: color,
            decimalPlaces: 0, // optional, defaults to 2dp
            fillShadowGradientOpacity: 0.2,
            color: (opacity = 1) => color,
            labelColor: (opacity = 1) => `rgba(0, 0, 0, ${opacity})`,
            useShadowColorFromDataset: true,
            style: {
              borderRadius: 16,
            },
            propsForDots: {
              r: "0",
              strokeWidth: "2",
              stroke: "rgba(0,0,0,.05)",
            },
            propsForBackgroundLines: {
              strokeWidth: "0",
            },
          }}
          style={{
            marginVertical: 8,
            borderRadius: 16,
          }}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  whatsappButton: {
    backgroundColor: "#075E54",
    flexDirection: "row",
    borderRadius: 27,
    height: 36,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 12,
  },
  text: {
    color: "#fff",
  },
});

export default ChartComponent;
